import React from 'react'

// material ui
import Box from '@mui/material/Box'

// components
import Button from './Button'
import Form from './Form'

const AddGuestPass = props => {
  const {
    formOpen // via withState
  } = props

  return (
    <Box mt={0}>{formOpen ? <Form {...props} /> : <Button {...props} />}</Box>
  )
}

export default AddGuestPass
